<template>
  <div class="option">
    <v-expansion-panels v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header class="expansion-header">
          <template v-slot:default="{ open }">
            <div class="option-header">
              <!--
              <div class="collapse-toggle-container">
                <font-awesome-icon
                  class="collapse-toggle"
                  :icon="collapsed ? 'chevron-right' : 'chevron-down'"
                  size="lg"
                />
              </div>
              -->
              <div class="header-img-spacer">
                <div
                  class="header-img-container"
                  :class="{selected: option.SelectedValue, 'show-photos': option.ShowPhotos}"
                  style="position: relative;"
                >
                  <img
                    v-if="option.SelectedValue"
                    class="header-img"
                    :src="option.SelectedValue.PhotoUrl"
                  />
                </div>
              </div>
              <div>
                <div class="option-name">{{option.Name}}:</div>
                <div
                  class="header-value"
                  :class="{selected: (option.SelectedValue != null) && (option.SelectedValue.Name == theValue.Name), 'text-danger': !option.SelectedValue }"
                >
                  <div class="header-value-name">{{theValue ? theValue.Name : "Not Selected"}}</div>
                  <div class="header-value-notes">{{theValue ? theValue.Notes : ""}}</div>
                </div>
              </div>
              <v-spacer></v-spacer>
              <v-text-field
                v-if="open"
                type="text"
                v-model="search"
                label="Search..."
                @click.stop
                outlined
                hide-details
                dense
                style="max-width: 200px;"
                background-color="white"
                class="search-input"
              ></v-text-field>
              <!--
              <b-form-input
                v-if="open"
                type="text"
                v-model="search"
                placeholder="Search..."
                class="search-input"
                @click.stop
              />
              -->
            </div>
          </template>
        </v-expansion-panel-header>

        <v-expansion-panel-content @hidden="search = ''" class="option-collapse">
          <div class="option-values">
            <value
              v-for="value in filteredValues"
              :key="value.Id"
              :value="value"
              :show-photos="option.ShowPhotos"
              :selected-value-id="(option.SelectedValue == null) ? null : option.SelectedValue.Id"
              @click.native="onValueClick(value)"
              @mouseover.native="onValueMouseover(value)"
              @mouseleave.native="onValueMouseleave(value)"
            ></value>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import Value from "./Value.vue";

export default {
  components: {
    Value
  },
  props: {
    item: Object,
    option: Object
  },
  data: function() {
    return {
      search: "",
      panel: !this.option.SelectedValue ? [0] : [],
      hoverValue: null
    };
  },
  computed: {
    selectedValueName: function() {
      return this.option.SelectedValue == null
        ? "Not Selected"
        : this.option.SelectedValue.Name;
    },
    filteredValues: function() {
      var searchUpperCase = this.search.toUpperCase();

      return this.option.Values.filter(value =>
        value.Name.toUpperCase().includes(searchUpperCase)
      );
    },
    theValue: function() {
      return this.hoverValue ? this.hoverValue : this.option.SelectedValue;
    }
  },
  methods: {
    onValueClick: function(value) {
      this.$store.dispatch("setItemOptionValue2", {
        item: this.item,
        option: this.option,
        value: value
      });

      this.panel = [];
    },
    onValueMouseover: function(value) {
      this.hoverValue = value;
    },
    onValueMouseleave: function() {
      this.hoverValue = null;
    }
  },
  watch: {
    "option.SelectedValue": function(newValue) {
      this.hoverValue = newValue;
    },
    panel: function(value) {
      if (!value) {
        this.search = "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.expansion-header {
  //border-bottom: 1px solid black;
}

.header-value {
  &:not(.selected) {
    opacity: 0.5;
  }

  .header-value-name {
    font-size: 18px;
    font-weight: 100;
    //font-style: italic;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .header-value-notes {
    height: 18px;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.option {
  box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.1);
  border: 1px solid lightgray;
}

.option-header {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: white;
  //background-color: rgb(240, 240, 240);
  padding: 5px;
  cursor: pointer;
}

.collapse-toggle-container {
  align-self: center;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15px;
  height: 15px;
  margin-left: 10px;
}

.header-img-spacer {
  height: 60px;
  width: 60px;
  //margin: 0px 30px;
  margin-right: 30px;

  .header-img-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    overflow: hidden;

    &.selected {
      &.show-photos {
        border: 1px solid lightgray;
      }

      &:not(.show-photos) {
        border: none;
        opacity: 0.25;
      }
    }

    &:not(.selected) {
      border: 1px solid lightgray;
    }

    .header-img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
    }
  }
}

.search-input {
  width: 200px;
  height: 25px;
  margin-left: auto;
  background-color: rgb(250, 250, 250);
}

.option-collapse {
  padding: 5px;
}
</style>